
// import { Navigation } from "swiper";
// import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
// import "swiper/swiper-bundle.css";
// import UiScrollableSlider from "~/components/UI/UiScrollableSlider.vue";
// import PrevArrowSvg from "~/components/svg/PrevArrowSvg.vue";
// import NextArrowSvg from "~/components/svg/NextArrowSvg.vue";
import useProductMixin from "~/mixins/useProductMixin";
import UiLazyImg from "~/components/UI/UiLazyImg.vue";

export default {
  name: "ProductComplimentCard",
  components: { UiLazyImg },
  mixins: [useProductMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    hover: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    product: {
      handler(val) {
        this.productData = val;
      },
      immediate: true,
    },
  },
};
